import { Link, useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  useTheme,
} from '@mui/material';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useThemeMode } from '../theme/ThemeProvider';
import { useAppSelector } from '../store/hooks';
import logoWhite from '../assets/images/logo-white.png';

const Navigation = () => {
  const location = useLocation();
  const theme = useTheme();
  const { mode, toggleTheme } = useThemeMode();
  const { isValid, operator } = useAppSelector((state) => state.auth);
  const isAuthenticated = isValid && operator;

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: theme.palette.primary.dark }}
    >
      <Toolbar>
        <Box
          component={Link}
          to={isAuthenticated ? '/predictor' : '/'}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            textDecoration: 'none',
            flexGrow: { xs: 1, sm: 0 },
            pl: { xs: 2, sm: 3 },
          }}
        >
          <Box
            component="img"
            src={logoWhite}
            alt="Tarana Logo"
            sx={{
              height: 32,
              width: 'auto',
            }}
          />
          <Typography
            variant="h6"
            sx={{
              textDecoration: 'none',
              color: theme.palette.common.white,
            }}
          >
            Service Predictor
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: 2,
            ml: { xs: 0, sm: 4 },
            flexGrow: { xs: 0, sm: 1 },
          }}
        >
          {isAuthenticated && (
            <Button
              component={Link}
              to="/predictor"
              color="inherit"
              sx={{
                backgroundColor: isActive('/predictor')
                  ? theme.palette.primary.main
                  : 'transparent',
                color: theme.palette.common.white,
                fontWeight: isActive('/predictor') ? 600 : 400,
                '&:hover': {
                  backgroundColor: isActive('/predictor')
                    ? theme.palette.primary.main
                    : 'rgba(97, 218, 251, 0.1)',
                  color: theme.palette.common.white,
                },
              }}
            >
              Service Predictor
            </Button>
          )}
          <Button
            component={Link}
            to="/about"
            color="inherit"
            sx={{
              backgroundColor: isActive('/about')
                ? theme.palette.primary.main
                : 'transparent',
              color: theme.palette.common.white,
              fontWeight: isActive('/about') ? 600 : 400,
              '&:hover': {
                backgroundColor: isActive('/about')
                  ? theme.palette.primary.main
                  : 'rgba(97, 218, 251, 0.1)',
                color: theme.palette.common.white,
              },
            }}
          >
            About
          </Button>
        </Box>
        <IconButton
          onClick={toggleTheme}
          color="inherit"
          sx={{ ml: 2, mr: { xs: 2, sm: 3 } }}
          aria-label="toggle theme"
        >
          {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default Navigation;
